import { render, staticRenderFns } from "./InputFilesList.vue?vue&type=template&id=1afe78b3&"
import script from "./InputFilesList.vue?vue&type=script&lang=js&"
export * from "./InputFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports